import React, { useLayoutEffect, useMemo, useRef } from "react";
var GAP = ':';
export default function WWOpenDataCom(_a) {
    var type = _a.type, openid = _a.openid;
    var ref = useRef(null);
    useLayoutEffect(function () {
        ref.current && window.WWOpenData.bind(ref.current);
    });
    var _openDataOpenId = useMemo(function () {
        if (openid && openid.includes(':')) {
            return openid.split(GAP)[1];
        }
        return openid;
    }, [openid]);
    return React.createElement("ww-open-data", { ref: ref, type: type, openid: _openDataOpenId });
}
